const clientTypes = {
  PARCELS: "parcels",
  FULFIL: "fulfilment",
};

export default clientTypes;
